import { motion } from 'motion/react'
import { SkeletonBlock, customerMotionTransition } from '../customer-area'

export const OrdersToolbarSkeleton = () => (
  <div className="space-y-3">
    <div className="grid gap-2 lg:grid-cols-[minmax(0,1fr)_auto_240px]">
      <SkeletonBlock className="h-10 rounded-lg" />
      <SkeletonBlock className="h-10 w-24 rounded-lg" />
      <SkeletonBlock className="h-10 rounded-lg" />
    </div>
    <SkeletonBlock className="h-24 rounded-lg" />
  </div>
)

export const OrdersRowsSkeleton = ({ reducedMotion = false }: { reducedMotion?: boolean }) => (
  <div className="space-y-3 p-3 sm:p-4">
    {Array.from({ length: 4 }).map((_, index) => (
      <motion.div
        key={`order-skeleton-${index}`}
        initial={reducedMotion ? { opacity: 0 } : { opacity: 0, y: 4 }}
        animate={reducedMotion ? { opacity: 1 } : { opacity: 1, y: 0 }}
        transition={
          reducedMotion
            ? { duration: 0 }
            : { duration: 0.18, ease: customerMotionTransition.ease, delay: index * 0.06 }
        }
        className="ca-theme-transition rounded-xl border border-(--color-border-default) bg-[color-mix(in_srgb,var(--color-bg-card)_96%,var(--color-bg-surface-muted))] px-4 py-4 shadow-(--shadow-sm) sm:px-5"
      >
        <div className="grid gap-3 sm:grid-cols-[minmax(0,1fr)_auto]">
          <div className="space-y-2.5">
            <div className="flex items-center gap-2">
              <SkeletonBlock className="h-4 w-40 rounded-md" />
              <SkeletonBlock className="h-5 w-24 rounded-full" />
            </div>
            <div className="flex items-center gap-2">
              <SkeletonBlock className="h-5 w-5 rounded-md" />
              <SkeletonBlock className="h-3 w-52 rounded-md" />
            </div>
            <SkeletonBlock className="h-3 w-24 rounded-md" />
          </div>
          <div className="space-y-2 sm:text-right">
            <SkeletonBlock className="ml-auto h-3 w-20 rounded-md" />
            <SkeletonBlock className="ml-auto h-4 w-24 rounded-md" />
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-2">
          <SkeletonBlock className="h-8 w-36 rounded-[10px]" />
          <SkeletonBlock className="h-8 w-28 rounded-[10px]" />
          <SkeletonBlock className="h-8 w-28 rounded-[10px]" />
        </div>
      </motion.div>
    ))}
  </div>
)
